import React, { useState, useEffect, useRef } from "react";
import "./Navbar.css";
import { useLanguage } from "../LanguageContext"; // 🔹 NEW

export default function Navbar() {
    const [menuOpen, setMenuOpen] = useState(false);
    const [showSearch, setShowSearch] = useState(false);
    const [query, setQuery] = useState("");
    const menuRef = useRef(null);
    const formRef = useRef(null);

    const { lang, setLang } = useLanguage(); // 🔹 language from context

    const BASE_URL =
        process.env.REACT_APP_API_URL?.replace(/\/api\/?$/, "") ||
        process.env.REACT_APP_API_BASE_URL?.replace(/\/api\/?$/, "") ||
        "http://localhost:8000";

    // 🔹 helper for translating labels
    const t = {
        home:
            lang === "sr" ? "Pocetna" :
                lang === "de" ? "Startseite" :
                    "Home",
        about:
            lang === "sr" ? "О nama" :
                lang === "de" ? "Über uns" :
                    "About",
        lessons:
            lang === "sr" ? "Lekcije" :
                lang === "de" ? "Lektionen" :
                    "Lessons",
        games:
            lang === "sr" ? "Igre" :
                lang === "de" ? "Spiele" :
                    "Games",
        resources:
            lang === "sr" ? "Materijali" :
                lang === "de" ? "Arbeitsblätter" :
                    "Resources",
        contact:
            lang === "sr" ? "Kontakt" :
                lang === "de" ? "Kontakt" :
                    "Contact",
        pricing:
            lang === "sr" ? "Cena" :
                lang === "de" ? "Preise" :
                    "Pricing",
        searchPlaceholder:
            lang === "sr" ? "Pretraga..." :
                lang === "de" ? "Suchen..." :
                    "Search...",
    };

    const changeLang = (code) => {
        setLang(code);

        // keep ?lang= in URL in sync
        const params = new URLSearchParams(window.location.search);
        params.set("lang", code);
        const newUrl = `${ window.location.pathname }?${ params.toString() }`;
        window.history.replaceState({}, "", newUrl);
    };

    // ✅ Close mobile menu when clicking outside
    useEffect(() => {
        function handleClickOutside(event) {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setMenuOpen(false);
            }
        }
        if (menuOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [menuOpen]);

    // ✅ Close search when clicking outside
    useEffect(() => {
        function handleSearchOutside(event) {
            if (formRef.current && !formRef.current.contains(event.target)) {
                setShowSearch(false);
            }
        }
        if (showSearch) {
            document.addEventListener("mousedown", handleSearchOutside);
        } else {
            document.removeEventListener("mousedown", handleSearchOutside);
        }
        return () => document.removeEventListener("mousedown", handleSearchOutside);
    }, [showSearch]);


    return (
        <header className="react-navbar-root">
            <nav className="react-navbar">
                {/* 🔹 Left: Hamburger */}
                <button
                    type="button"
                    className={`react-navbar-toggle ${ menuOpen ? "open" : "" }`}
                    onClick={() => setMenuOpen(!menuOpen)}
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </button>

                {/* 🔹 Center: Logo */}
                <a href={`${ BASE_URL }/?lang=${ lang }`} className="react-navbar-logo">
                    <img
                        src={`${ BASE_URL }/static/assets/images/Logonew.png`}
                        alt="FunlishLand"
                    />
                </a>

                {/* 🔹 Desktop language switcher (right of logo, before search) */}
                <div className="react-lang-switcher d-none d-md-flex">
                    <button
                        type="button"
                        className={lang === "en" ? "fl-lang-active" : ""}
                        onClick={() => changeLang("en")}
                    >
                        EN
                    </button>
                    <span>|</span>
                    <button
                        type="button"
                        className={lang === "sr" ? "fl-lang-active" : ""}
                        onClick={() => changeLang("sr")}
                    >
                        SR
                    </button>
                    <span>|</span>
                    <button
                        type="button"
                        className={lang === "de" ? "fl-lang-active" : ""}
                        onClick={() => changeLang("de")}
                    >
                        DE
                    </button>
                </div>

                {/* 🔹 Right: Search */}
                <div className="react-navbar-search">
                    {!showSearch ? (
                        <button
                            className="search-toggle"
                            onClick={(e) => {
                                e.preventDefault();
                                setShowSearch(true);
                            }}
                        >
                            🔍
                        </button>
                    ) : (
                        <div ref={formRef} className="search-form">
                            <form method="get" action={`${ BASE_URL }/lessons/search/`}>
                                <input
                                    type="text"
                                    name="q"
                                    placeholder={t.searchPlaceholder}
                                    value={query}
                                    onChange={(e) => setQuery(e.target.value)}
                                    autoFocus
                                />
                                {/* send lang to Django search as well */}
                                <input type="hidden" name="lang" value={lang} />
                                <button type="submit">Go</button>
                            </form>
                        </div>
                    )}
                </div>

                {/* 🔹 Slide Menu (mobile + small screens) */}
                <ul
                    ref={menuRef}
                    className={`react-navbar-menu ${ menuOpen ? "active" : "" }`}
                >
                    {/* Mobile language switcher at top */}
                    <li className="react-lang-switcher-mobile d-md-none">
                        <button
                            type="button"
                            className={lang === "en" ? "fl-lang-active" : ""}
                            onClick={() => changeLang("en")}
                        >
                            EN
                        </button>
                        <span>|</span>
                        <button
                            type="button"
                            className={lang === "sr" ? "fl-lang-active" : ""}
                            onClick={() => changeLang("sr")}
                        >
                            SR
                        </button>
                        <span>|</span>
                        <button
                            type="button"
                            className={lang === "de" ? "fl-lang-active" : ""}
                            onClick={() => changeLang("de")}
                        >
                            DE
                        </button>
                    </li>

                    <li>
                        <a
                            href={`${ BASE_URL }/?lang=${ lang }`}
                            onClick={() => setMenuOpen(false)}
                        >
                            {t.home}
                        </a>
                    </li>
                    <li>
                        <a
                            href={`${ BASE_URL }/about/?lang=${ lang }`}
                            onClick={() => setMenuOpen(false)}
                        >
                            {t.about}
                        </a>
                    </li>
                    <li>
                        <a
                            href={`${ BASE_URL }/lessons/?lang=${ lang }`}
                            onClick={() => setMenuOpen(false)}
                        >
                            {t.lessons}
                        </a>
                    </li>

                    {/* We are already on Games (React), but keep label translated */}
                    <li>
                        <a
                            href={`https://api.funlishland.com/?lang=${ lang }`}
                            onClick={() => setMenuOpen(false)}
                        >
                            {t.games}
                        </a>
                    </li>

                    <li>
                        <a
                            href={`${ BASE_URL }/resources/?lang=${ lang }`}
                            onClick={() => setMenuOpen(false)}
                        >
                            {t.resources}
                        </a>
                    </li>
                    <li>
                        <a
                            href={`${ BASE_URL }/contact/?lang=${ lang }`}
                            onClick={() => setMenuOpen(false)}
                        >
                            {t.contact}
                        </a>
                    </li>
                    <li>
                        <a
                            href="/pricing"
                            onClick={() => setMenuOpen(false)}
                        >
                            {t.pricing}
                        </a>
                    </li>

                    <button
                        className="menu-close"
                        onClick={() => setMenuOpen(false)}
                    >
                        ✕
                    </button>
                </ul>
            </nav>
        </header>
    );
}
